import { ActionTemplateResultsQuery } from 'generated/graphql';

export type ActionTemplate = NonNullable<
  ActionTemplateResultsQuery['actionTemplateResults']
>['templates'][number];

export enum IncentiveUnit {
  'co2' = 'co2',
  'tree' = 'tree',
  'USD' = 'USD',
}
